import React from 'react';
import {useDispatch, useSelector} from 'react-redux'
import { closePopup } from '../../../actions/popup';
import {isDaumBlogDomain} from "../../../utils/UriUtil";

function PopupMessage({resultCode, resultMessage}) {
  if (isDaumBlogDomain()) {
    switch (resultCode) {
      case 'canNotCloseBlog':
        return <p className="txt_popup">{resultMessage}</p>
      case 'invalidPassword':
        return (
          <p className="txt_popup">
            비밀번호가 일치하지 않습니다.
          </p>
        )
      case 'closedBlogFail':
        return (
          <p className="txt_popup">
            블로그 폐쇄가 진행되지 못했습니다.
          </p>
        )
      case 'closedBlogTempFail':
        return (
          <p className="txt_popup">
            일시적인 오류로 블로그 폐쇄가 진행되지 못했습니다.
            잠시 후 다시 시도해주세요.
          </p>
        )
      case 'closedBlogDone':
        return (
          <p className="txt_popup">
            블로그를 정상적으로 폐쇄하였습니다.
          </p>
        )
      default:
        return null
    }
  } else {
    switch (resultCode) {
      case 'canNotCloseBlog':
        return <p className="txt_popup">{resultMessage}</p>
      case 'sendClosingConfirmEmail':
        return (
          <p className="txt_popup">
            안전한 블로그 폐쇄를 위해 로그인 아이디 <span className="txt_em">‘{resultMessage}’</span>로 인증메일이 발송되었습니다. 메일을 확인하여 블로그 폐쇄를 완료해 주세요.
          </p>
        )
      case 'onlyBlog':
        return (
          <p className="txt_popup">
            이 블로그는 <span className="txt_em">‘{resultMessage}’</span>님이 운영 중인 유일한 블로그입니다. 운영 중인 블로그가 1개인 경우 블로그 폐쇄와 동시에 회원 탈퇴가 이루어집니다.
          </p>
        )
      default:
        return null
    }
  }
}

export default function CloseBlogResultPopup() {
  const popupOpened = useSelector(state => state.popup.closeBlogResultPopupOpened)
  const resultCode = useSelector(state => state.popup.clearBlogResultCode)
  const resultMessage = useSelector(state => state.popup.clearBlogResultMessage)
  const dispatch = useDispatch()

  function handlePopupClose() {
    dispatch(closePopup())
  }

  function handleConfirm() {
    handlePopupClose();

    if (isDaumBlogDomain() && resultCode === 'closedBlogDone') {
      window.location = window.appInfo.topUrl;
    }

    if (isDaumBlogDomain() && resultCode === 'closedBlogTempFail') {
      window.location = window.appInfo.manageUrl + "/setting/blog";
    }

    if (resultCode === 'onlyBlog') {
      window.location = window.appInfo.topUrl + "/member/account/quit"
    }
  }

  return (
    <div className="blog_layer" style={{position: 'fixed', top: '50%', marginTop: '-112px', display: popupOpened?'block':'none'}}>
      <div className="inner_blog_layer inner_blog_layer1">
        <div className="cont_layer">
          <strong className="tit_popup">블로그 폐쇄 확인</strong>
          <PopupMessage resultCode={resultCode} resultMessage={resultMessage} />
        </div>
        <div className="fld_btn">
          <button type="button" className="btn_cancel" onClick={() => handlePopupClose()}>취소</button>
          <button type="submit" className="btn_default" onClick={() => handleConfirm()}>확인</button>
        </div>
      </div>
    </div>
  )
}
